import React, { useState, useContext, createContext } from "react";
import { ManageAsJobModal } from "../../ProjectsTable/Modals";

interface ModalContextType {
  confirmManageAsJob(orderId: string, callback?: () => void): void;
}

const ModalContext = createContext<ModalContextType>({
  confirmManageAsJob() {
    throw new Error("not implemented");
  },
});

type ModalProviderProps = {
  children: React.ReactChild;
};

export const ModalProvider = ({
  children,
}: ModalProviderProps): React.ReactElement => {
  const [manageAsJobOrderState, setManageAsJobOrderState] = useState<{
    orderId?: string;
    callback?: () => void;
  }>({
    orderId: undefined,
    callback: undefined,
  });

  const value: ModalContextType = {
    confirmManageAsJob(orderId: string, callback?: () => void) {
      if (!manageAsJobOrderState.orderId) {
        setManageAsJobOrderState({
          orderId,
          callback,
        });
      } else {
        console.warn(
          `Manage As Job Modal already opened for order ${manageAsJobOrderState.orderId}`
        );
      }
    },
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
      {manageAsJobOrderState.orderId && (
        <ManageAsJobModal
          modalOpen={!!manageAsJobOrderState.orderId}
          orderId={manageAsJobOrderState.orderId}
          toggleModal={open => {
            if (!open) {
              setManageAsJobOrderState({
                orderId: undefined,
                callback: undefined,
              });
            }
          }}
          onSubmit={manageAsJobOrderState.callback}
        />
      )}
    </ModalContext.Provider>
  );
};

export function useModal() {
  return useContext(ModalContext);
}
